import { Languages } from "../../types";
import { createServiceContractDictionary } from "./CreateServiceContract";
import { serviceContractDebitsDictionary } from "./ServiceContractDebits";
import { serviceContractsDictionary } from "./ServiceContracts";
import { ServiceContractPagesDescriptions } from "./types";

export const getServiceContractDescriptions = (systemLang: Languages): ServiceContractPagesDescriptions => ({
    CREATE_SERVICE_CONTRACT: createServiceContractDictionary[systemLang],
    SERVICE_CONTRACTS: serviceContractsDictionary[systemLang],
    SERVICE_CONTRACT_DEBITS: serviceContractDebitsDictionary[systemLang],
})